import { render, staticRenderFns } from "./MorePopup.vue?vue&type=template&id=29ff274e"
import script from "./MorePopup.vue?vue&type=script&lang=js"
export * from "./MorePopup.vue?vue&type=script&lang=js"
import style0 from "./MorePopup.vue?vue&type=style&index=0&id=29ff274e&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports